module.exports = __webpack_public_path__ + "static/media/DSC00392.43c5481f.jpg";